import type { JSX, PropsWithChildren } from 'react';

import { StarterDashboardV2BannerStateContextProvider } from './context';
import { useBannerState } from './hook';

export function StarterDashboardV2BannerStateProvider({ children }: PropsWithChildren<EmptyProps>): JSX.Element | null {
	const bannerState = useBannerState();

	return (
		<StarterDashboardV2BannerStateContextProvider {...bannerState}>
			{children}
		</StarterDashboardV2BannerStateContextProvider>
	);
}
